import { render } from "./HomeContact.vue?vue&type=template&id=512ab831&scoped=true"
import script from "./HomeContact.vue?vue&type=script&lang=js"
export * from "./HomeContact.vue?vue&type=script&lang=js"

import "./HomeContact.vue?vue&type=style&index=0&id=512ab831&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Alison\\Documents\\Dev\\Apps\\av2-portfolio-v3\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-512ab831"]])

export default __exports__